module.exports = __webpack_public_path__ + "img/023-sleep.cd8f4dc2.svg";